export default "__VITE_ASSET__DQrZL2Xb__"